import React from "react";

import { ReactComponent as ArbitrumIcon } from "@/shared/icons/token/arbitrum.svg";
import { ReactComponent as EthIcon } from "@/shared/icons/token/eth.svg";
import { ReactComponent as GmxIcon } from "@/shared/icons/token/gmx.svg";
import { ReactComponent as UsdcIcon } from "@/shared/icons/token/usdc.svg";
import { ReactComponent as WbtcIcon } from "@/shared/icons/token/wbtc.svg";

import { Token } from "../constants";

export const getIconByToken = (token: Token) => {
  const iconByToken: Record<Token, React.ReactNode> = {
    [Token.ARB]: <ArbitrumIcon />,
    [Token.GMX]: <GmxIcon />,
    [Token.USDC]: <UsdcIcon />,
    [Token.USDCE]: <UsdcIcon />,
    [Token.WETH]: <EthIcon />,
    [Token.WBTC]: <WbtcIcon />,
  };
  return iconByToken[token];
};
